/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DeleteAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import ConfirmationDialog from './ConfirmationDialog/index'
import React from 'react'
import Tysiav2DeleteFilled from 'DesignSystem/Svgs/Tysiav2DeleteFilled/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function DeleteAction({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Note/ViewNoteDialog/DeleteAction"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
  return (<React.Fragment
>
<button
  data-testid="DeleteAction.Horizontal"
  data-view-path={viewPath}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'ConfirmationDialog/Content'))}
 {...isHoveredBind}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2DeleteFilled
  viewPath={`${viewPath}/Tysiav2DeleteFilled`}
 width={dtSpaceLs}
 height={dtSpaceLs}
 fill2="#513C06"
/>
</button>
<ConfirmationDialog
  viewPath={`${viewPath}/ConfirmationDialog`}
/>
{children}
</React.Fragment>)
}